import { Http } from "../../../support";

const initialState = {
  busy: false,
  result: undefined,
  error: undefined,
};

const upsert = async (store, data, id) => {
  store.setState((state) => {
    state.app.prefacturas.upsert.busy = true;
  });

  try {
    let response;

    if (!id) {
      response = await Http.post('api/prefacturas', data);
    } else {
      response = await Http.put(`api/prefacturas/${id}`, data);
    }

    store.setState((state) => {
      state.app.prefacturas.upsert = {
        ...state.app.prefacturas.upsert,
        busy: false,
        result: response
      }
    });
  } catch (error) {
    store.setState((state) => {
      state.app.prefacturas.upsert = {
        ...state.app.prefacturas.upsert,
        busy: false,
        error: error.data || error
      }
    });
  }
}

const reset = (store) => state => {
  state.app.prefacturas.upsert = {
    ...initialState
  };
};

const actions = {
  upsert,
  reset,
}

const PrefacturaUpsertStore = {
  state: () => initialState,
  actions
}

export default PrefacturaUpsertStore;